var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCustomDnbWallet(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 30.29 29.55"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "custom_dnb_wallet_svg__cls-1",
    d: "M27.92 13.81V9.26a2.75 2.75 0 00-2.65-2.67H24m3.9 7.22H22a1.24 1.24 0 00-1.25 1.26V19A1.23 1.23 0 0022 20.25h6.54A1.24 1.24 0 0029.79 19v-3.93a1.24 1.24 0 00-1.25-1.26zM24 6.59l-1.54-5.18a1.17 1.17 0 00-1.71-.79L7 6.59m17 0H7m20.92 13.82v6a2.75 2.75 0 01-2.65 2.67H3.15a2.75 2.75 0 01-2.65-2.7V9.26a2.75 2.75 0 012.65-2.67H7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "custom_dnb_wallet_svg__cls-1",
    d: "M24 18.37a1.26 1.26 0 10-1.24-1.26A1.25 1.25 0 0024 18.37z"
  })))));
}

export default SvgCustomDnbWallet;